module.exports = __webpack_public_path__ + "static/media/texture (40).767986bc.jpg";